module.exports = __webpack_public_path__ + "static/img/avatar2.451fadc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar2.png
// module id = ciMv
// module chunks = 7